export const thTH = {
  language: 'th_TH',
  translation: {
    APP: 'ROI',
    TITLE:
      'โครงการจัดทำระบบฐานข้อมูลการเรียนรู้เชิงลึกการบริหารจัดการน้ำและการเพาะปลูก',
    SUB_TITLE:
      'ฝ่ายจัดสรรน้ำที่ 1 ส่วนบริหารจัดการน้ำสำนักบริหารจัดการน้ำและอุทกวิทยากรมชลประทาน',
    MENU: {
      DRY_SEASON: 'จัดสรรน้ำฤดูแล้ง',
      COMMON: 'ข้อมูลพื้นฐาน',
      SETTING: 'ตั้งค่าระบบ',
    },
    POPUP: {
      SAVE: {
        TITLE: 'บันทึก',
        MESSAGE: 'คุณต้องการบันทึกข้อมูลหรือไม่',
      },
      EDIT: {
        TITLE: 'แก้ไข',
        MESSAGE: 'คุณต้องการแก้ไขข้อมูลหรือไม่',
      },
      REMOVE: {
        TITLE: 'ลบ',
        MESSAGE: 'คุณต้องการลบข้อมูลหรือไม่',
      },
      ERROR: {
        TITLE: 'เกิดข้อผิดพลาด',
      },
      COMPLETE: 'สำเร็จ',
      SAVE_ROS_GIS: {
        TITLE: 'บันทึก',
        MESSAGE:
          'คุณยังไม่ได้อัพโหลดไฟล์แนบ ROS และ GIS ยืนยันจะบันทึกหรือไม่ ?',
      },
      SAVE_ROS: {
        TITLE: 'บันทึก',
        MESSAGE: 'คุณยังไม่ได้อัพโหลดไฟล์แนบ ROS ยืนยันจะบันทึกหรือไม่ ?',
      },
      SAVE_GIS: {
        TITLE: 'บันทึก',
        MESSAGE: 'คุณยังไม่ได้อัพโหลดไฟล์แนบ GIS ยืนยันจะบันทึกหรือไม่ ?',
      },
      NOTIFICATION: {
        TITLE: 'การแจ้งเตือน',
        MESSAGE: 'ไม่มีการแจ้งเตือน',
        BUTTON: 'ดูการแจ้งเตือนทั้งหมด',
      },
      CONVERSATION: {
        TITLE: 'ข้อความ',
      },
      BUTTON: {
        CLOSE: 'ปิด',
        SAVE: 'บันทึก',
        EDIT: 'แก้ไข',
        CANCEL: 'ยกเลิก',
        OK: 'ตกลง',
      },
    },
    SELECT: {
      VALUE: {
        PLEASE_SELECT: 'กรุณาเลือก',
        ALL: 'ทั้งหมด',
      },
      YEAR: {
        LABEL: 'ปีจัดสรรน้ำฤดูแล้ง',
        PLACEHOLDER: 'เลือกปีจัดสรรน้ำฤดูแล้ง',
      },
      PROVINCE: {
        LABEL: 'จังหวัด',
        PLACEHOLDER: 'เลือกจังหวัด',
      },
      IRRIGATION_DEPARTMENT: {
        LABEL: 'สำนักงานชลประทาน',
        PLACEHOLDER: 'เลือกสำนักงานชลประทาน',
      },
      PROJECT: {
        LABEL: 'โครงการ',
        PLACEHOLDER: 'เลือกโครงการ',
      },
      RESERVOIR: {
        LABEL: 'อ่างเก็บน้ำ',
        PLACEHOLDER: 'เลือกอ่างเก็บน้ำ',
      },
      STATUS: {
        LABEL: 'สถานะ',
        PLACEHOLDER: 'เลือกสถานะ',
      },
      NATURAL_WATER: {
        LABEL: 'แหล่งน้ำธรรมชาติ',
        PLACEHOLDER: 'เลือกแหล่งน้ำ',
      },
      APPROVE_TYPE: {
        LABEL: 'การจัดสรรน้ำโครงการ',
        PLACEHOLDER: 'เลือกโครงการ',
      },
      OTHER_MEDIUM_RESERVOIR: {
        LABEL: 'อ่างเก็บน้ำขนาดกลางอื่นๆ',
        PLACEHOLDER: 'เลือกอ่างเก็บน้ำ',
      },
      WATER_SOURCE: {
        LABEL: 'แหล่งน้ำอื่นๆ',
        PLACEHOLDER: 'เลือกแหล่งน้ำ',
      },
    },
    STATUS: {
      WATER_ALLOCATED: 'ได้รับการพิจารณาจาก สชป.',
      PENDING: 'อยู่ระหว่างการดำเนินการ',
      WAIT_APPROVE: 'อยู่ระหว่างพิจารณาจาก สชป.',
      NO_ALLOCATION: 'ทบทวนแก้ไข',
      IS_DEPARTMENT_CHANGED: 'แก้ไขโดย สชป.',
      LABEL: {
        PROJECT: 'โครงการ',
      },
    },
    BUTTON: {
      SEARCH: 'ค้นหา',
      ADD: 'เพิ่ม',
      CLOSE: 'ปิด',
      FILE: 'ดาวน์โหลดไฟล์แนบ',
      DOWNLOAD: 'ดาวน์โหลด',
      ROS_FILE: 'ไฟล์แนบ ROS',
      GIS_FILE: 'ไฟล์แนบ GIS',
      CONFIRM: 'ยืนยัน',
      MONTHLY: 'ความต้องการน้ำรายเดือน',
      ADD_DAILY: 'จัดทำแผนจัดสรรน้ำรายวัน',
      ADD_WEEKLY: 'จัดทำแผนจัดสรรน้ำรายสัปดาห์',
      ADD_PROJECT: 'เพิ่มข้อมูลโครงการ',
      SELECT_FILE: 'เลือกไฟล์',
      DOWNLOAD_TEMP: 'ดาวน์โหลดตัวอย่างเอกสาร',
      IMPORT_PLAN: 'อัพโหลดแผนจัดสรรน้ำรายวัน',
      IMPORT_DAILY: 'อัพโหลดแผนจัดสรรน้ำรายวัน',
      SHOW_FLOW: 'แสดงแผนผังน้ำ',
      GUIDE: 'คู่มือ',
      CHANGE_PASSWORD: 'เปลี่ยนรหัสผ่าน',
      LANGUAGE: 'ภาษา',
      SIGN_OUT: 'ออกจากระบบ',
      REPLY: 'ตอบกลับ',
    },
    TABLE: {
      HEADER: {
        SEQUENCE: 'ลำดับ',
        YEAR: 'ปีจัดสรรน้ำฤดูแล้ง',
        IRRIGATION_DEPARTMENT: 'สชป.',
        RESERVOIR: 'อ่างเก็บน้ำ',
        PROJECTS: 'โครงการ',
        PROVINCE: 'จังหวัด',
        AREA: 'พื้นที่ (ไร่)',
        WATER_VOLUME_1NOV: 'ปริมาณน้ำ ณ วันที่ 1 พ.ย.',
        CURRENT_WATER: 'ปริมาณน้ำ ณ ปัจจุบัน',
        FORECASTED: 'คาดการณ์ปริมาณน้ำต้นทุน',
        WATER_VOLUME: 'ปริมาณน้ำ (ล้านลูกบาศก์เมตร)',
        AREA_IRRIGATION: 'พื้นที่ชลประทาน',
        AREA_CULTIVATION: 'พื้นที่เพาะปลูก (ไร่)',
        WATER_PERIOD: 'ระยะเวลาส่งน้ำ',
        TOTAL: 'รวมทั้งหมด',
        START_DATE: 'เริ่ม',
        END_DATE: 'สิ้นสุด',
        RESERVOIR_OTHER: 'อ่างน้ำ / อ่างน้ำอื่นๆ /แหล่งน้ำอื่นๆ',
        MENU: 'เมนูจัดสรรน้ำ',
        STATUS: 'สถานะ',
        FILE: 'ไฟล์แนบ',
        APPROVE_TYPE: 'การจัดสรรน้ำโครงการ',
        REMARK: 'หมายเหตุ',
        MANAGE: 'จัดการ',
        UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
        TOTAL_MCM: 'รวมทั้งหมด (ล้านลูกบาศก์เมตร)',
        DATE: 'วันที่',
        WEEK_NO: 'สัปดาห์ที่',
        PERIOD: 'ช่วงวันที่',
        LARGE_RESERVOIR_DAILY:
          'แผนการจัดสรรน้ำรายวันในอ่างเก็บน้ำขนาดใหญ่ (ล้านลูกบาศก์เมตร)',
        LARGE_RESERVOIR_WEEKLY:
          'แผนการจัดสรรน้ำรายสัปดาห์ในอ่างเก็บน้ำขนาดใหญ่ (ล้านลูกบาศก์เมตร)',
        MEDIUM_RESERVOIR_DAILY:
          'แผนการจัดสรรน้ำรายวันในอ่างเก็บน้ำขนาดใหญ่ (ล้านลูกบาศก์เมตร)',
        MEDIUM_RESERVOIR_WEEKLY:
          'แผนการจัดสรรน้ำรายสัปดาห์ในอ่างเก็บน้ำขนาดใหญ่ (ล้านลูกบาศก์เมตร)',
        MONTHLY_DEMAND: ' ความต้องการน้ำรายเดือน (ล้านลูกบาศก์เมตร)',
        MONTH_YEAR: 'เดือน / ปี',
        WATER_SOURCE: 'แหล่งน้ำ',
      },
    },
    INPUT: {
      START_DATE: {
        LABEL: 'วันที่เริ่มต้น',
        PLACEHOLDER: 'วันที่เริ่มต้น',
        VALIDATE: {
          REQUIRED: 'ต้องระบุข้อมูลนี้',
        },
      },
      END_DATE: {
        LABEL: 'วันที่สิ้นสุด',
        PLACEHOLDER: 'วันที่สิ้นสุด',
        VALIDATE: {
          REQUIRED: 'ต้องระบุข้อมูลนี้',
        },
      },
      WATER_VOLUME_1NOV: {
        LABEL: 'ปริมาณน้ำ ณ วันที่ 1 พ.ย.',
        PLACEHOLDER: '',
        VALIDATE: {
          REQUIRED: 'ต้องระบุข้อมูลนี้',
        },
      },
      CURRENT_WATER: {
        LABEL: 'ปริมาณน้ำ ณ ปัจจุบัน',
        PLACEHOLDER: '',
        VALIDATE: {
          REQUIRED: 'ต้องระบุข้อมูลนี้',
        },
      },
      FORECASTED: {
        LABEL: 'คาดการณ์ปริมาณน้ำต้นทุน (ล้านลูกบาศก์เมตร)',
        PLACEHOLDER: 'คาดการณ์ปริมาณน้ำต้นทุน',
        VALIDATE: {
          REQUIRED: 'ต้องระบุข้อมูลนี้',
          MAX: 'คาดการณ์ปริมาณน้ำต้นทุนต้องน้อยกว่า',
        },
      },
      COMMENT: {
        LABEL: 'หมายเหตุ',
        PLACEHOLDER:
          'หากปริมาณน้ำที่จัดสรรมากกว่าคาดการณ์ปริมาณน้ำต้นทุนต้องระบุหมายเหตุ',
        VALIDATE: {
          REQUIRED:
            'กรุณากรอกหมายเหตุเนื่องจากปริมาณน้ำมากกว่าคาดการณ์ปริมาณน้ำต้นทุน',
        },
      },
      REMARK: {
        LABEL: 'หมายเหตุ',
        PLACEHOLDER: 'ระบุหมายเหตุของการไม่อนุมัติ',
        VALIDATE: {
          REQUIRED: 'ต้องระบุข้อมูลนี้',
        },
      },
      ROS: {
        LABEL: 'ไฟล์ ROS',
      },
      GIS: {
        LABEL: 'ไฟล์ GIS',
      },
      WATER_SOURCE: {
        LABEL: 'แหล่งน้ำอื่นๆ',
        PLACEHOLDER: 'ชื่อแหล่งน้ำ',
      },

      CONVERSATION: {
        LABEL: '',
        PLACEHOLDER: 'เพิ่มหัวข้อเรื่อง',
      },
    },
    FILE_NAME: {
      TEMPLATE_DAILY: 'ตัวอย่างแผนจัดสรรน้ำรายวัน',
      PLAN_DAILY: 'แผนจัดสรรน้ำรายวัน',
      WEEKLY_DAILY: 'แผนจัดสรรน้ำรายสัปดาห์',
    },
    PAGE: {
      DASHBOARD: {
        TOTAL: {
          WATER: 'รวมปริมาณน้ำ',
          LAND: 'รวมพื้นที่คาดการณ์',
        },
        TABLE: {
          TOTAL: 'รวม',
          DAM: 'เขื่อน',
        },
        TAB: {
          NATIONWIDE: {
            NAME: 'จัดสรรน้ำทั่วประเทศ',
            TITLE_WATER: 'แผนการจัดสรรน้ำ ',
            TITLE_LAND: 'แผนการเพาะปลูก',
          },
          RIVERBASIN: {
            NAME: 'จัดสรรตามลุ่มน้ำ',
            TITLE_WATER: 'แผนการจัดสรรน้ำ',
            TITLE_LAND: 'แผนการเพาะปลูก',
            RAI: 'ไร่',
            MCM: 'ล้าน ลบ.ม.',
            TITLE_POPUP: 'แผนการจัดสรรน้ำและเพาะปลูกพืชลุ่มน้ำ',
            REMARK: 'หมายเหตุ : แผนการจัดสรรน้ำจากอ่างเก็บน้ำขนาดใหญ่',
          },
          NATURAL_WATER: {
            NAME: 'จัดสรรแหล่งน้ำธรรมชาติ',
          },
        },
        CHART: {
          NO_DATA: 'ไม่พบข้อมูล',
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          YEAR: {
            LABEL: 'ปีจัดสรรน้ำฤดูแล้ง',
            PLACEHOLDER: 'เลือกปีจัดสรรน้ำฤดูแล้ง',
          },
          PROVINCE: {
            LABEL: 'จังหวัด',
            PLACEHOLDER: 'เลือกจังหวัด',
          },
          IRRIGATION_DEPARTMENT: {
            LABEL: 'สำนักงานชลประทาน',
            PLACEHOLDER: 'เลือกสำนักงานชลประทาน',
          },
          PROJECT: {
            LABEL: 'โครงการ',
            PLACEHOLDER: 'เลือกโครงการ',
          },
          NATURAL_WATER: {
            LABEL: 'แหล่งน้ำ',
            PLACEHOLDER: 'เลือกแหล่งน้ำ',
          },
        },
      },
      RESERVOIR: {
        TITLE: 'อ่างเก็บน้ำ',
        NAV: {
          RESERVOIR_LARGE_SIZE: 'อ่างเก็บน้ำขนาดใหญ่',
          RESERVOIR_MIDDLE_SIZE: 'อ่างเก็บน้ำขนาดกลาง',
          WATER_VOLUME_1NOV: 'ข้อมูลปริมาณน้ำ ณ วันที่ 1 พ.ย.',
        },
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            RESERVOIR: 'อ่างเก็บน้ำ',
            RESPONSIBLE_PROJECTS: 'โครงการที่รับผิดชอบ',
            IRRIGATION_DEPARTMENT: 'สำนักงานชลประทาน',
            PROVINCE: 'จังหวัด',
            CAPACITY_LEVEL: 'ความจุที่ระดับ (ล้านลูกบาศก์เมตร)',
            CAPACITY_WATER: 'ความจุน้ำใช้การ (ล้านลูกบาศก์เมตร)',
            WATER_LEVEL: 'ระดับน้ำ (ม.รทก.)',
            UNIT_01: 'รนส.',
            UNIT_02: 'รนก.',
            UNIT_03: 'รนต.',
            MAIN_BASIN: 'ลุ่มน้ำหลัก',
            SUB_BASIN: 'ลุ่มน้ำย่อย',
            RESERVOIR_TYPE: 'ประเภทอ่างเก็บน้ำ',
            WATER_VOLUME: 'ปริมาณน้ำ ณ วันที่ 1 พ.ย.',
            DATE_SYNC: 'วันที่ทำรายการ',
            TOTAL: 'รวมปริมาณน้ำ {{value}} ล้านลูกบาศก์เมตร',
            MANAGE: 'จัดการ',
          },
          INPUT: {
            RESERVOIR_NAME: {
              LABEL: 'ชื่ออ่างเก็บน้ำ',
            },
          },
        },
        MANAGE: {
          HEADER: {
            ADD_RESERVOIR: 'เพิ่มอ่างเก็บน้ำ',
            EDIT_RESERVOIR: 'แก้ไขอ่างเก็บน้ำ',
            EDIT_LIMIT: 'กำหนดค่าคาดการณ์ปริมาณน้ำต้นทุน',
            UPDATE_WATER_VOLUME: 'อัปเดตข้อมูลปริมาณน้ำ',
          },
          LABEL: {
            CAPACITY_WATER: 'ความจุน้ำใช้การ (ล้านลูกบาศก์เมตร)',
            CAPACITY_LEVEL: 'ความจุที่ระดับ (ล้านลูกบาศก์เมตร)',
            WATER_LEVEL: 'ระดับน้ำ (ม.รทก.)',
            RESERVOIR_LARGE_SIZE: 'อ่างเก็บน้ำขนาดใหญ่ (ล้านลูกบาศก์เมตร)',
            RESERVOIR_MIDDLE_SIZE: 'อ่างเก็บน้ำขนาดกลาง (ล้านลูกบาศก์เมตร)',
          },
          PLACEHOLDER: {
            RESERVOIR_LARGE_SIZE: 'คาดการณ์ปริมาณน้ำต้นทุนอ่างเก็บน้ำขนาดใหญ่',
            RESERVOIR_MIDDLE_SIZE: 'คาดการณ์ปริมาณน้ำต้นทุนอ่างเก็บน้ำขนาดกลาง',
          },
        },
        INPUT: {
          RESERVOIR_NAME: {
            LABEL: 'อ่างเก็บน้ำ',
            PLACEHOLDER: 'ระบุอ่างเก็บน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          UNIT_01: {
            LABEL: 'รนส.',
            PLACEHOLDER: 'ระดับน้ำสูงสุด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          UNIT_02: {
            LABEL: 'รนก.',
            PLACEHOLDER: 'ระดับน้ำปกติ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          UNIT_03: {
            LABEL: 'รนต.',
            PLACEHOLDER: 'ระดับน้ำต่ำสุด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },

          LATITUDE: {
            LABEL: 'ละติจูด',
            PLACEHOLDER: 'ละติจูด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          LONGITUDE: {
            LABEL: 'ลองติจูด',
            PLACEHOLDER: 'ลองติจูด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          IRRIGATION_DEPARTMENT: {
            LABEL: 'สำนักงานชลประทาน',
            PLACEHOLDER: 'สำนักงานชลประทาน',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          PROJECT: {
            LABEL: 'โครงการ',
            PLACEHOLDER: 'โครงการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          RESERVOIR: {
            LABEL: 'อ่างเก็บน้ำ',
            PLACEHOLDER: 'อ่างเก็บน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          RESERVOIR_SIZE: {
            LABEL: 'ขนาดอ่างเก็บน้ำ',
            PLACEHOLDER: 'ขนาดอ่างเก็บน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          PROVINCE: {
            LABEL: 'จังหวัด',
            PLACEHOLDER: 'จังหวัด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          DISTRICT: {
            LABEL: 'อำเภอ',
            PLACEHOLDER: 'อำเภอ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SUB_DISTRICT: {
            LABEL: 'ตำบล',
            PLACEHOLDER: 'ตำบล',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          MAIN_BASIN: {
            LABEL: 'ลุ่มน้ำหลัก',
            PLACEHOLDER: 'ระบุลุ่มน้ำหลัก',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SUB_BASIN: {
            LABEL: 'ลุ่มน้ำย่อย',
            PLACEHOLDER: 'ระบุลุ่มน้ำย่อย',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          RESERVOIR_TYPE: {
            LABEL: 'ประเภทอ่างเก็บน้ำ',
            PLACEHOLDER: 'ระบุประเภท',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
            VALUE: {
              MAJOR: 'อ่างเก็บน้ำขนาดใหญ่',
              MEDIUM: 'อ่างเก็บน้ำขนาดกลาง',
            },
          },
        },
        POPUP: {
          SAVE: {
            TITLE: 'ยืนยัน',
            MESSAGE: 'คุณต้องการอัปเดตข้อมูลปริมาณน้ำหรือไม่',
          },
        },
        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD_RESERVOIR: 'เพิ่มอ่างเก็บน้ำ',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
          SYNC: 'อัปเดตข้อมูลปริมาณน้ำ',
        },
      },
      DRY_SEASON: {
        TITLE: 'ตั้งค่าปีจัดสรรน้ำฤดูแล้ง',
        POPUP: {
          TITLE: 'สรุปตั้งค่าจัดสรรน้ำฤดูแล้ง',
        },
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            YEAR: 'ปีจัดสรรน้ำฤดูแล้ง',
            DETAIL: 'รายละเอียด',
            PERIOD: 'ระยะเวลาในการจัดทำแผน',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่มข้อมูล',
            EDIT: 'แก้ไขข้อมูล',
            PERIOD: 'ระยะเวลาในการจัดทำแผน',
            SWITCH:
              'ปิดการจัดสรรน้ำฤดูแล้งและนำเข้าข้อมูลการจัดสรรแสดงบนแดชบอร์ด',
          },
        },
        INPUT: {
          YEAR: {
            LABEL: 'ปีจัดสรรน้ำ',
            PLACEHOLDER: 'ปีจัดสรรน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          DETAIL: {
            LABEL: 'รายละเอียด',
            PLACEHOLDER: 'ระบุรายละเอียด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          START_DATE: {
            LABEL: 'วันที่เริ่มต้น',
            PLACEHOLDER: 'ระบุวันเริ่มต้น',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          END_DATE: {
            LABEL: 'วันที่สิ้นสุด',
            PLACEHOLDER: 'ระบุวันสิ้นสุด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
        },
        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่มข้อมูล',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      WATER_OTHER: {
        TITLE: 'ประเภทแหล่งน้ำอื่น',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            FULL_NAME: 'ชื่อ',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
        },
        INPUT: {
          SEARCH: {
            LABEL: 'ค้นหา',
            PLACEHOLDER: 'ค้นหา',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          NAME: {
            LABEL: 'ชื่อ',
            PLACEHOLDER: 'ชื่อ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHORT_NAME: {
            LABEL: 'ชื่อย่อ',
            PLACEHOLDER: 'ชื่อย่อ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_FULL_NAME: {
            LABEL: 'แสดงชื่อเต็ม',
            PLACEHOLDER: 'แสดงชื่อเต็ม',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_SHORT_NAME: {
            LABEL: 'แสดงชื่อย่อ',
            PLACEHOLDER: 'แสดงชื่อย่อ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          FULL_NAME: {
            LABEL: 'ชื่อเต็ม',
            PLACEHOLDER: 'ชื่อเต็ม',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHORT_NAME: {
            LABEL: 'ชื่อย่อ',
            PLACEHOLDER: 'ชื่อย่อ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่ม',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      PROJECT: {
        TITLE: 'โครงการ',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            IRRIGATION_DEPARTMENT: 'สำนักงานชลประทาน',
            NAME: 'ชื่อโครงการ',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'ชื่อโครงการ',
            PLACEHOLDER: 'ชื่อโครงการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          DETAIL: {
            LABEL: 'รายละเอียด',
            PLACEHOLDER: 'รายละเอียด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          NAME: {
            LABEL: 'ชื่อโครงการ',
            PLACEHOLDER: 'ชื่อโครงการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          IRRIGATION_DEPARTMENT: {
            LABEL: 'สำนักงานชลประทาน',
            PLACEHOLDER: 'สำนักงานชลประทาน',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่ม',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      USER: {
        TITLE: 'ผู้ใช้งาน',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            USER: 'ชื่อผู้ใช้งาน',
            EMAIL: 'อีเมล',
            ROLE: 'สังกัดหน่วยงาน',
            STATUS: 'สถานะ',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
            CHANGE_PASSWORD: 'เปลี่ยนรหัสผ่าน',
          },
          PASSWORD: {
            CONDITION_1: 'รหัสผ่านต้องมีความยาว อย่างน้อย 8 ตัวอักษร',
            CONDITION_2: 'ต้องมีตัวอักษรพิมพ์ใหญ่อย่างน้อย 1 ตัว (A-Z)',
            CONDITION_3: 'ต้องมีตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัว (a-z)',
            CONDITION_4: 'รหัสผ่านต้องมีตัวเลขอย่างน้อย 1 ตัว  (0-9)',
            CONDITION_5:
              'รหัสผ่านต้องมีอักขระพิเศษอย่างน้อย 1 ตัว (!#$%&*:;?&#64;~)',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'ชื่อผู้ใช้งาน',
            PLACEHOLDER: 'ชื่อผู้ใช้งาน',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          EMAIL: {
            LABEL: 'อีเมล์',
            PLACEHOLDER: 'อีเมล์',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
              PATTERN: 'อีเมล์ไม่ถูกต้อง',
            },
          },
          CONFIRM_PASSWORD: {
            LABEL: 'ยืนยันหัสผ่าน',
            PLACEHOLDER: 'ยืนยันหัสผ่าน',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
              PATTERN: 'รหัสผ่านไม่ตรงกัน',
            },
          },
          PASSWORD: {
            LABEL: 'รหัสผ่าน',
            PLACEHOLDER: 'รหัสผ่าน',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
              PATTERN: 'รหัสผ่านไม่ถูกต้อง',
            },
          },
          SHOW_PASSWORD: {
            LABEL: 'แสดงรหัสผ่าน',
            PLACEHOLDER: 'รหัสผ่าน',
          },
          NEW_PASSWORD: {
            LABEL: 'รหัสผ่านใหม่',
            PLACEHOLDER: 'รหัสผ่านใหม่',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
              PATTERN: 'รหัสผ่านไม่ถูกต้อง',
            },
          },
          OLD_PASSWORD: {
            LABEL: 'รหัสผ่านเดิม',
            PLACEHOLDER: 'รหัสผ่านเดิม',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
              PATTERN: 'รหัสผ่านไม่ถูกต้อง',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          OFFICE: {
            LABEL: 'สำนักชลประทาน',
            PLACEHOLDER: 'เลือกสำนักชลประทาน',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          ROLE: {
            LABEL: 'สังกัดหน่วยงาน',
            PLACEHOLDER: 'เลือกสังกัดหน่วยงาน',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          TITLE_NAME: {
            LABEL: 'คำนำหน้า',
            PLACEHOLDER: 'คำนำหน้า',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          AFFILIATION: {
            LABEL: 'สังกัด',
            PLACEHOLDER: 'เลือกสังกัด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่ม',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      ROLE: {
        TITLE: 'สังกัดหน่วยงาน',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            NAME: 'ชื่อ',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
          BODY: {
            LABEL: {
              PERMISSION: 'การอนุญาต',
              VIEW: 'อ่าน',
              CREATE: 'สร้าง',
              UPDATE: 'ปรับปรุง',
              DELETE: 'ลบ',
              UPLOAD: 'อัพโหลด',
              DOWNLOAD: 'ดาวน์โหลด',
            },
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'ชื่อ',
            PLACEHOLDER: 'ชื่อ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          NAME: {
            LABEL: 'ชื่อ',
            PLACEHOLDER: 'ชื่อ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          OPTION: {
            LABEL: 'Option',
            PLACEHOLDER: 'เลือก',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่ม',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      PLAN_WATER_DRY_SEASON: {
        MIDDLE_RESERVIOR_MANAGE: {
          HEADER: {
            ADD: 'เพิ่มอ่างเก็บน้ำ',
            EDIT: 'จัดทำแผนจัดสรรน้ำฤดูแล้ง',
          },
        },
        APPROVAL: {
          TITLE: 'รายการรออนุมัติแผนการจัดสรรน้ำ',
          APPROVE_TYPE: {
            MAJOR_RESERVOIR: 'อ่างเก็บน้ำขนาดใหญ่',
            OTHER_MAJOR: 'โครงการชลประทานขนาดใหญ่',
            MEDIUM_RESERVOIR: 'อ่างเก็บน้ำขนาดกลาง',
            OTHER_MEDIUM_RESERVOIR: 'อ่างเก็บน้ำขนาดกลางอื่นๆ',
            OTHER_WATER_SOURCE: 'ฝาย ประตูระบายน้ำและอื่นๆ',
            NATURAL_WATER: 'แหล่งน้ำธรรมชาติ',
            MAEKLONG: 'ลุ่มน้ำแม่กลอง',
            CHAOPHRAYA: 'ลุ่มน้ำเจ้าพระยา',
          },
          BUTTON: {
            BACK: 'ย้อนกลับ',
            APPROVE: 'อนุมัติ',
            NOT_APPROVE: 'ไม่อนุมัติ',
          },
          POPUP: {
            APPROVE: {
              TITLE: 'บันทึก',
              MESSAGE: 'ยืนยันการอนุมัติหรือไม่ ?',
            },
            REJECT: {
              TITLE: 'บันทึก',
              MESSAGE: 'ยืนยันไม่อนุมัติหรือไม่ ?',
            },
          },
        },
        LARGE_RESERVOIR: {
          TITLE: 'แผนการจัดสรรน้ำจากอ่างเก็บน้ำขนาดใหญ่',
          TAB_1: 'แผนจัดสรรน้ำอ่างเก็บน้ำขนาดใหญ่',
          TAB_2: 'แผนรายโครงการ',
          MANAGE: {
            HEADER: 'แก้ไขข้อมูลแผนจัดสรรน้ำอ่างเก็บน้ำขนาดใหญ่รายโครงการ',
          },
        },
        LARGE_PROJECT: {
          TITLE: 'ข้อมูลโครงการเก็บน้ำขนาดใหญ่',
        },
        TAB_PLAN: {
          DAILY: 'แผนจัดสรรน้ำรายวัน',
          WEEKLY: 'แผนจัดสรรน้ำรายสัปดาห์',
        },
        OTHER_LARGE_RESERVOIR: {
          TITLE: 'แผนการจัดสรรน้ำสำหรับโครงการชลประทานขนาดใหญ่',
          BUTTON: {
            ADD_PROJECT: 'สร้างโครงการเก็บน้ำใหญ่อื่นๆ',
          },
        },
        OTHER_LARGE_PROJECT: {
          TITLE: 'ข้อมูลโครงการเก็บน้ำขนาดใหญ่อื่นๆ',
          MANAGE: {
            ADD: 'เพิ่มข้อมูลโครงการจังหวัด',
            TURN_BACK: 'จัดสรรอ่างเก็บน้ำขนาดใหญ่อื่นๆ',
          },
        },
        MEDIUM_RESERVOIR: {
          TITLE: 'แผนจัดสรรน้ำจากอ่างเก็บน้ำขนาดกลางที่ถ่ายโอนภารกิจแล้ว',
          TAB_1: 'แผนจัดสรรน้ำอ่างเก็บน้ำขนาดกลาง',
          TAB_2: 'แผนรายโครงการ',
          MANAGE: {
            HEADER: 'แก้ไขข้อมูลแผนจัดสรรน้ำอ่างเก็บน้ำขนาดกลางรายโครงการ',
          },
        },
        MEDIUM_PROJECT: {
          TITLE: 'ข้อมูลโครงการเก็บน้ำขนาดกลาง',
        },
        OTHER_MEDIUM: {
          TITLE: 'แผนการจัดสรรน้ำจากอ่างเก็บน้ำขนาดกลางอื่นๆ',
        },
        OTHER_MEDIUM_PROJECT: {
          TITLE: 'ข้อมูลโครงการเก็บน้ำขนาดกลางอื่นๆ',
          BUTTON: { TURN_BACK: 'จัดสรรอ่างเก็บน้ำขนาดกลางอื่นๆ' },
        },
        OTHER_WATER: {
          TITLE: 'แผนการจัดสรรน้ำจากฝาย ประตูระบายน้ำ และอื่นๆ',
          BUTTON: {
            ADD: ' สร้างข้อมูลแหล่งน้ำอื่นๆ',
          },
        },
        OTHER_WATER_PROJECT: {
          TITLE: 'ข้อมูลโครงการแหล่งน้ำอื่นๆ',
          BUTTON: { TURN_BACK: 'กลับไปที่จัดสรรน้ำแหล่งน้ำอื่นๆ' },
        },
        NATURAL_WATER: {
          TITLE: 'แผนการจัดสรรน้ำแหล่งน้ำธรรมชาติ',
        },
        NATURAL_WATER_PROJECT: {
          TITLE: 'ข้อมูลโครงการแหล่งน้ำธรรมชาติ',
          BUTTON: { TURN_BACK: 'กลับไปที่จัดสรรน้ำแหล่งน้ำธรรมชาติ' },
        },
        MAEKLONG: {
          TITLE: 'แผนการจัดสรรน้ำรายวัน/รายสัปดาห์ลุ่มน้ำแม่กลอง',
          HEADER: {
            DAILY: 'แผนการจัดสรรน้ำรายวันในลุ่มน้ำแม่กลอง (ล้านลูกบาศก์เมตร)',
            WEEKLY:
              'แผนการจัดสรรน้ำรายสัปดาห์ในลุ่มน้ำแม่กลอง (ล้านลูกบาศก์เมตร)',
            MONTHLY: ' ความต้องการน้ำรายเดือนลุ่มน้ำแม่กลอง',
          },
          MANAGE: {
            HEADER_DAILY: 'จัดทำแผนจัดสรรน้ำฤดูแล้งรายวันลุ่มน้ำแม่กลอง',
            HEADER_WEEKLY: 'จัดทำแผนจัดสรรน้ำฤดูแล้งรายสัปดาห์ลุ่มน้ำแม่กลอง',
          },
        },
        MAEKLONG_PROJECT_PLAN: {
          TITLE: 'แผนการจัดสรรน้ำในลุ่มน้ำแม่กลองรายโครงการ',
        },
        MAEKLONG_PROJECT: {
          TITLE: 'ข้อมูลโครงการลุ่มน้ำแม่กลอง',
          BUTTON: { TURN_BACK: 'กลับไปที่จัดสรรน้ำลุ่มน้ำแม่กลอง' },
        },
        CHAOPHRAYA_DAM: {
          TITLE: 'แผนการจัดสรรน้ำรายวัน/รายสัปดาห์ 4 เขื่อนเจ้าพระยา',
          HEADER: {
            DAILY:
              'แผนการจัดสรรน้ำรายวันในลุ่มน้ำแม่เจ้าพระยา (ล้านลูกบาศก์เมตร)',
            WEEKLY:
              'แผนการจัดสรรน้ำรายสัปดาห์ในลุ่มน้ำแม่เจ้าพระยา (ล้านลูกบาศก์เมตร)',
            MONTHLY: 'ความต้องการน้ำรายเดือนลุ่มน้ำเจ้าพระยา',
          },
          MANAGE: {
            HEADER_DAILY: 'นำเข้าข้อมูลจัดสรรน้ำรายวันลุ่มน้ำเจ้าพระยา',
            HEADER_WEEKLY: 'นำเข้าข้อมูลจัดสรรน้ำรายสัปดาห์ลุ่มน้ำเจ้าพระยา',
          },
        },
        CHAOPHRAYA_PLAN: {
          TITLE: 'แผนการจัดสรรน้ำรายวัน/รายสัปดาห์ลุ่มน้ำเจ้าพระยา',
          TAB: {
            TAB_1:
              'แผนการจัดสรรน้ำรายสัปดาห์ในลุ่มน้ำเจ้าพระยาในระดับคลองส่งน้ำในช่วงฤดูแล้ง',
            TAB_2: 'แผนจัดสรรน้ำรายสัปดาห์',
            TAB_3: 'สชป.3',
            TAB_4: 'สชป.4',
            TAB_5: 'สชป.10',
            TAB_6: 'สชป.11',
            TAB_7: 'สชป.12',
          },
          TABLE_20: {
            HEADER: {
              UPSTREM_CHAOPHRAYA: 'เหนือเขื่อนเจ้าพระยา',
              PUMPING: 'สูบน้ำด้วยไฟฟ้า',
              TDD_WB: 'ส่งน้ำฯ ทด,วบ,วย-นช',
              NAKHONSAWAN: 'ชป. นครสวรรค์',
              KHUNDAN: 'ส่งน้ำฯ ขน.',
              YOMNAN: 'ส่งน้ำฯ ยม-น่าน',
              UNIT: 'ส่งน้ำฯ พล.,ดฐ.,ทบ.',
              KWANNOI: 'ส่งน้ำฯ แควน้อย',
              THACHIN: 'แม่น้ำท่าจีน',
              NOI_RIVER: 'แม่น้ำน้อย',
              ROI_12: 'สชป. 12',
              ROI_11: 'สชป. 11',
              ROI_1011: 'สชป.10-11',
              SUM_ROI_1011: 'รวม สชป.10-11',
              PSU_CANAL: 'คลอง ม.อ.',
              SMALL_CANAL: 'คลองเล็กอื่นๆ',
              SUM_1211: 'รวม สชป.12-11',
              ROI_1211: 'สชป.12-11',
              MANOROM: 'มโนรมย์',
              MAHARAT: 'มหาราช',
              SUM_1011: 'รวม สชป.10-11',
              SUM_101112: 'รวม สชป.10,11 และ 12',
              DOWNSTREM: 'ระบายท้ายเชื่อนเจ้าพระยา',
              SIRIKIT: 'รวมความต้องการน้ำจากเขื่อนภูมิพลและสิริกิต์',
              DEMAND_KWANNOI: 'ความต้องการใช้น้ำจากเขื่อนแควน้อยฯ',
              DEMAND_PASAK: 'ความต้องการใช้น้ำจากเขื่อนป่าสักฯ',
              MAEKLONG: 'ผันน้ำจากลุ่มน้ำแม่กลอง',
              TOTAL_DEMAND:
                'รวมความต้องการใช้น้ำจากเขื่อนภูมิพล,สิริกิต์,แควน้อยฯ,ป่าสักฯ และลุ่มน้ำแม่กลอง',
            },
          },
          TABLE_19: {
            HEADER: {
              DEMAND_SIRIKIT: 'ความต้องการน้ำจากอ่างฯภูมิพลและสิริกิติ์',
              UPSTREM_CHAOPHRAYA: 'ความต้องการน้ำเหนือเขื่อนเจ้าพระยา',
              PUMPING: 'สูบน้ำด้วยไฟฟ้า',
              CATCHMENT: 'การรับน้ำเข้าพื้นที่',
              TDD_WB: 'ส่งน้ำฯ ทด,วบ,วย-นข',
              NAKHONSAWAN: 'ชป. นครสวรรค์',
              KHUNDAN: 'ส่งน้ำฯเขื่อนนเรศวร',
              YOMNAN: 'ส่งน้ำฯ ยม-น่าน',
              UNIT: 'ส่งน้ำฯ พล.,ดฐ.,ทบ.',
              KWANNOI: 'ส่งน้ำฯ แควน้อย',
              WESTERN: 'ทุ่งฝั่งตะวันตก (สชป.12,11)',
              EASTERN: 'ทุ่งฝั่งตะวันออก (สชป.10,11)',
              DOWNSTREM_CHAOPHRAYA: 'แผบการระบายน้ำท้ายเขื่อนเจ้าพระยา',
              DEMAND_KWANNOI: 'ความต้องการน้ำจากอ่างฯแควน้อยฯ',
              DEMAND_PASAK: 'ความต้องการน้ำจากอ่างฯป่าสักฯ',
              RAMAVI: 'แผนการระบายน้ำห้วยเขื่อนพระรามหก',
              PHOPHRAYA: 'แผนการระบายน้ำห้วยปตร.โพธิ์พระยา',
              MAEKLONG: 'ผันน้ำจากลุ่มน้ำแม่กลอง',
              EASTERN_FOODPLAIN: 'การรับน้ำทุ่งฝั่งตะวันออก',
              ROI_10: 'สชป.10',
              ROI_11: 'สชป.11',
            },
          },
        },

        CHAOPHRAYA_PROJECT_PLAN: {
          TITLE: 'แผนการจัดสรรน้ำในลุ่มน้ำเจ้าพระยารายโครงการ',
          HEADER: {
            WATER: 'ปริมาณน้ำที่จัดสรรได้ : {{value}} ล้านลูกบาศก์เมตร',
          },
        },
        CHAOPHRAYA_FLOW: {
          TITLE: 'แผนผังการจัดสรรน้ำในลุ่มน้ำเจ้าพระยา',
          SUB_TITLE: '(หน่วย : ล้านลูกบาศก์เมตร)',
          HEADER: {
            BHUMIBOL: 'การระบายน้ำจากอ่างภูมิพลและสิริกิต์',
            KWAENOI: 'การระบายน้ำจากอ่างฯ แควน้อยฯ',
            UPSTREM_CHAOPHRAYA: 'การใช้น้ำเหนือเขื่อนเจ้าพระยา',
            WESTERN: 'การใช้น้ำทุ่งฝั่งตะวันตก',
            EASTERN: 'การใช้น้ำทุ่งฝั่งตะวันออก',
            UPPER_FIELD: 'ทุ่งตอนบน',
            UPPER_LOWER: 'ทุ่งตอนบนและตอนล่าง',
            MAEKLONG: 'ผันน้ำจากลุ่มน้ำแม่กลอง',
            PASAK: 'ระบายน้ำจากอ่างฯ ป่าสักฯ',
            LOWER_FOODPLAIN: 'ทุ่งตอนล่าง',
            MWA: 'การประปานครหลวง',
            THACHIN: 'รักษาระบบนิเวศ และผลักดันน้ำเค็มปากแม่น้ำท่าจีน',
            CHAOPHRAYA: 'รักษาระบบนิเวศ และผลักดันน้ำเค็มปากแม่น้ำเจ้าพระยา',
            NAKHONSAWAN: 'จ.นครสวรรค์',
            CHAOPHRAYA_DAM: 'เขื่อนเจ้าพระยา',
            RIO_12: 'รวม สชป. 12',
            RIO_10: 'รวม สชป. 10',
            RIO_11: 'รวม สชป. 11',
            PHOPHRAYA: 'ปตร. โพธิ์พระยา',
            PHOKHOI: 'ปตร. โพธิ์คอย',
            PHAKHAICHAOCHET: 'ปตร. ผักให้เจ้าเจ็ด',
            RAMA_VI: 'เขื่อนพระรามหก',
            PHRASRISIN: 'ปตร. พระศรีศิลป์',
            PHRASRISAOWAPHAK: 'ปตร. พระศรีเสวภาค',
            PHRAYABUNLUE: 'ปตร. พระยาบรรลือ',
            SINGHANAT: 'สถานีสูบน้ำสิงหนาถ 2',
          },
        },
        CHAOPHRAYA_PROJECT: {
          TITLE: 'ข้อมูลโครงการลุ่มน้ำเจ้าพระยา',
          BUTTON: { TURN_BACK: 'กลับไปที่จัดสรรน้ำลุ่มน้ำเจ้าพระยา' },
          INPUT: {
            SEARCH: {
              LABEL: 'ค้นหา',
              PLACEHOLDER: 'ค้นหาชื่อโครงการ',
            },
          },
        },
        POPUP: {
          DAILY: {
            HEADER: 'นำเข้าข้อมูลจัดสรรน้ำรายวัน',
          },
          WEEKLY: {
            HEADER: 'จัดทำแผนจัดสรรน้ำฤดูแล้งรายสัปดาห์',
          },
          MONTHLY: {
            HEADER: 'ความต้องการน้ำรายเดือน',
          },
        },
      },

      ACTIVITY: {
        TITLE: 'กิจกรรมการใช้น้ำ',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับความสำคัญในการจัดสรรน้ำ',
            NAME: 'ชื่อ',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'ชื่อกิจกรรมการใช้น้ำ',
            PLACEHOLDER: 'ชื่อกิจกรรมการใช้น้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          ORDER: {
            LABEL: 'ลำดับความสำคัญในการจัดสรรน้ำ',
            PLACEHOLDER: 'ลำดับความสำคัญในการจัดสรรน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SEARCH: {
            LABEL: 'ค้นหา',
            PLACEHOLDER: 'ค้นหา',
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          NAME: {
            LABEL: 'ชื่อกิจกรรม',
            PLACEHOLDER: 'ชื่อกิจกรรม',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่ม',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      RIVERBASIN: {
        TITLE: 'ลุ่มน้ำ',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            CODE: 'รหัส',
            NAME: 'ชื่อลุ่มน้ำ',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'ชื่อลุ่มน้ำ',
            PLACEHOLDER: 'ชื่อลุ่มน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          AREA: {
            LABEL: 'พื้นที่',
            PLACEHOLDER: 'พื้นที่',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          CODE: {
            LABEL: 'รหัสลุ่มน้ำ',
            PLACEHOLDER: 'รหัสลุ่มน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          GEOMETRY: {
            LABEL:
              'อัพโหลดไฟล์พื้นที่ลุ่มน้ำสำเร็จแล้วหากต้องการแก้ไขกรุณากด "เพิ่มไฟล์"',
            PLACEHOLDER: '',
          },
          FILE: {
            LABEL: 'เพิ่มไฟล์พื้นที่ลุ่มน้ำ (.shx, .shp, .prj, .dbf, .cpg)',
            PLACEHOLDER: '',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
      },
      SUBBASIN: {
        TITLE: 'ลุ่มน้ำย่อย',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            NAME: 'ชื่อลุ่มน้ำย่อย',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'ชื่อลุ่มน้ำย่อย',
            PLACEHOLDER: 'ชื่อลุ่มน้ำย่อย',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
      },
      PLANT: {
        TITLE: 'ชนิดพืช',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับความสำคัญในการจัดสรรน้ำ',
            NAME: 'ชนิดพืช',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
        },
        INPUT: {
          NAME: {
            LABEL: 'ชนิดพืช',
            PLACEHOLDER: 'ชนิดพืช',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          ORDER: {
            LABEL: 'ลำดับความสำคัญในการจัดสรรน้ำ',
            PLACEHOLDER: 'ลำดับความสำคัญในการจัดสรรน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },

          SEARCH: {
            LABEL: 'ค้นหา',
            PLACEHOLDER: 'ค้นหา',
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          NAME: {
            LABEL: 'ชนิดพืช',
            PLACEHOLDER: 'ชนิดพืช',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่ม',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      NATURAL_WATER: {
        TITLE: 'แหล่งน้ำธรรมชาติ',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            FULL_NAME: 'ชื่อแหล่งน้ำ',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
        },
        INPUT: {
          SEARCH: {
            LABEL: 'ค้นหา',
            PLACEHOLDER: 'ค้นหา',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          NAME: {
            LABEL: 'ชื่อแหล่งน้ำ',
            PLACEHOLDER: 'ชื่อแหล่งน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          NAME: {
            LABEL: 'ชื่อแหล่งน้ำ',
            PLACEHOLDER: 'ชื่อแหล่งน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },

          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่ม',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      OTHER_MIDDLE_RESERVOIR: {
        TITLE: 'อ่างเก็บน้ำขนาดกลางอื่นๆ',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            RESERVOIR: 'อ่างเก็บน้ำ',
            RESPONSIBLE_PROJECTS: 'โครงการที่รับผิดชอบ',
            IRRIGATION_DEPARTMENT: 'สำนักงานชลประทาน',
            PROVINCE: 'จังหวัด',
            MAIN_BASIN: 'ลุ่มน้ำหลัก',
            SUB_BASIN: 'ลุ่มน้ำย่อย',
            MANAGE: 'จัดการ',
          },
          INPUT: {
            RESERVOIR_NAME: {
              LABEL: 'ชื่ออ่างเก็บน้ำ',
              PLACEHOLDER: 'ค้นหาอ่างเก็บน้ำ',
            },
          },
        },
        MANAGE: {
          HEADER: {
            ADD_RESERVOIR: 'เพิ่มอ่างเก็บน้ำ',
            EDIT_RESERVOIR: 'แก้ไขอ่างเก็บน้ำ',
          },
          LABEL: {
            CAPACITY_WATER: 'ความจุน้ำใช้การ (ล้านลูกบาศก์เมตร)',
            CAPACITY_LEVEL: 'ความจุที่ระดับ (ล้านลูกบาศก์เมตร)',
            WATER_LEVEL: 'ระดับน้ำ (ม.รทก.)',
          },
        },
        INPUT: {
          RESERVOIR_NAME: {
            LABEL: 'อ่างเก็บน้ำ',
            PLACEHOLDER: 'ระบุอ่างเก็บน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },

          LATITUDE: {
            LABEL: 'ละติจูด',
            PLACEHOLDER: 'ละติจูด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          LONGITUDE: {
            LABEL: 'ลองติจูด',
            PLACEHOLDER: 'ลองติจูด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          IRRIGATION_DEPARTMENT: {
            LABEL: 'สำนักงานชลประทาน',
            PLACEHOLDER: 'สำนักงานชลประทาน',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          PROJECT: {
            LABEL: 'โครงการ',
            PLACEHOLDER: 'โครงการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          RESERVOIR: {
            LABEL: 'อ่างเก็บน้ำ',
            PLACEHOLDER: 'อ่างเก็บน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          RESERVOIR_SIZE: {
            LABEL: 'ขนาดอ่างเก็บน้ำ',
            PLACEHOLDER: 'ขนาดอ่างเก็บน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          PROVINCE: {
            LABEL: 'จังหวัด',
            PLACEHOLDER: 'จังหวัด',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          DISTRICT: {
            LABEL: 'อำเภอ',
            PLACEHOLDER: 'อำเภอ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SUB_DISTRICT: {
            LABEL: 'ตำบล',
            PLACEHOLDER: 'ตำบล',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          MAIN_BASIN: {
            LABEL: 'ลุ่มน้ำหลัก',
            PLACEHOLDER: 'ระบุลุ่มน้ำหลัก',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SUB_BASIN: {
            LABEL: 'ลุ่มน้ำย่อย',
            PLACEHOLDER: 'ระบุลุ่มน้ำย่อย',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD_RESERVOIR: 'เพิ่มอ่างเก็บน้ำ',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      OTHER_WATER_SOURCE: {
        TITLE: 'แหล่งน้ำอื่นๆ',
        TABLE: {
          HEADER: {
            SEQUENCE: 'ลำดับ',
            NAME: 'ชื่อแหล่งน้ำ',
            WATER_TYPE: 'ประเภทแหล่งน้ำ',
            PROVINCE: 'จังหวัด',
            MAIN_BASIN: 'ลุ่มน้ำหลัก',
            SUB_BASIN: 'ลุ่มน้ำย่อย',
            UPDATE_DATE: 'วันที่ทำรายการล่าสุด',
            MANAGE: 'จัดการ',
          },
        },
        MANAGE: {
          HEADER: {
            ADD: 'เพิ่ม',
            EDIT: 'แก้ไข',
            DELETE: 'ลบ',
          },
        },
        INPUT: {
          SEARCH: {
            LABEL: 'ค้นหา',
            PLACEHOLDER: 'ค้นหา',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          NAME: {
            LABEL: 'ชื่อแหล่งน้ำ',
            PLACEHOLDER: 'ชื่อแหล่งน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        SELECT: {
          VALUE: {
            PLEASE_SELECT: 'กรุณาเลือก',
            ALL: 'ทั้งหมด',
          },
          NAME: {
            LABEL: 'ชื่อแหล่งน้ำ',
            PLACEHOLDER: 'ชื่อแหล่งน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          WATER_TYPE: {
            LABEL: 'ประเภทแหล่งน้ำ',
            PLACEHOLDER: 'เลือกประเภทแหล่งน้ำ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
          SHOW_ENTRY: {
            LABEL: 'จำนวนแสดงรายการ',
            PLACEHOLDER: 'จำนวนแสดงรายการ',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },

        BUTTON: {
          SEARCH: 'ค้นหา',
          ADD: 'เพิ่ม',
          CLOSE: 'ปิด',
          SAVE: 'บันทึก',
          EDIT: 'แก้ไข',
          CANCEL: 'ยกเลิก',
          OK: 'ตกลง',
        },
      },
      MENU: {
        TITLE: 'คำแนะนำเมนู',
        MANAGE: {
          ADD: 'เพิ่ม',
          EDIT: 'แก้ไข',
          DELETE: 'ลบ',
          MESSAGE_ENABLE: 'ยืนยันเปิดใช้งานคำแนะนำหรือไม่ ?',
          MESSAGE_DISABLE: 'ยืนยันปิดใช้งานคำแนะนำหรือไม่ ?',
        },
      },
      SUMMARY: {
        TAB: {
          PROJECT: {
            NAME: 'โครงการ',
            TITLE: 'สรุปแผนจัดสรรน้ำฤดูแล้งรายโครงการ',
          },
          PROVINCE: {
            NAME: 'โครงการจังหวัด',
            TITLE: 'สรุปแผนจัดสรรน้ำฤดูแล้งรายจังหวัด',
            REMARK_1: {
              NAME: 'หมายเหตุ',
              LABEL:
                'ข้อมูลปริมาณน้ำ,พื้นที่ชลประทานจะแสดงผลรวมเฉพาะสถานะได้รับการพิจารณาจาก สชป.แล้วเท่านั้น (หากต้องการดูรายละเอียดกดที่ชื่อโครงการ)',
            },
            REMARK_2: {
              NAME: 'หมายเหตุ',
              LABEL:
                'ข้อมูลปริมาณน้ำ,พื้นที่ชลประทานจะแสดงผลรวมเฉพาะสถานะได้รับการพิจารณาจาก สชป.แล้วเท่านั้น',
            },
          },
          STATUS: {
            NAME: 'ติดตามสถานะแผนการจัดสรรน้ำฤดูแล้ง',
            TITLE_LARGE_RESERVOIR: 'แผนการจัดสรรน้ำจากอ่างเก็บน้ำขนาดใหญ่',
            TITLE_OTHER_LARGE: 'แผนการจัดสรรน้ำสำหรับโครงการชลประทานขนาดใหญ่',
            TITLE_MEDIUM_RESERVOIR:
              'แผนจัดสรรน้ำจากอ่างเก็บน้ำขนาดกลางที่ถ่ายโอนภารกิจแล้ว',
            TITLE_OTHER_MEDIUM: 'แผนการจัดสรรน้ำจากอ่างเก็บน้ำขนาดกลางอื่นๆ',
            TITLE_OTHER_WATER: 'แผนการจัดสรรน้ำจากฝาย ประตูระบายน้ำ และอื่นๆ',
            TITLE_NATURAL_WATER: 'แผนการจัดสรรน้ำแหล่งน้ำธรรมชาติ',
            TITLE_MAEKLONG: 'แผนการจัดสรรน้ำในลุ่มน้ำแม่กลอง',
            TITLE_CHAOPHRAYA: 'แผนการจัดสรรน้ำในลุ่มน้ำเจ้าพระยา',
          },
        },
        TABLE: {
          HEADER: {
            YEAR: 'ปีจัดสรรน้ำฤดูแล้ง',
            IRRIGATION_DEPARTMENT: 'สชป.',
            PROJECTS: 'โครงการ',
            PROVINCE: 'จังหวัด',
            AREA: 'พื้นที่',
            WATER_VOLUME_1NOV: 'ปริมาณน้ำ ณ วันที่ 1 พ.ย.',
            CURRENT_WATER: ' ปริมาณน้ำ ณ ปัจจุบัน',
            FORECASTED: 'คาดการณ์ปริมาณน้ำต้นทุน',
            WATER_VOLUME: 'ปริมาณน้ำ (ล้านลูกบาศก์เมตร)',
            AREA_IRRIGATION: 'พื้นที่ชลประทาน',
            WATER_PERIOD: 'ระยะเวลาส่งน้ำ',
            TOTAL: 'รวมทั้งหมด',
            START_DATE: 'เริ่ม',
            END_DATE: 'สิ้นสุด',
            RESERVOIR_OTHER: 'อ่างน้ำ / อ่างน้ำอื่นๆ /แหล่งน้ำอื่นๆ',
            MENU: 'เมนูจัดสรรน้ำ',
            STATUS: 'สถานะ',
            FILE: 'ไฟล์แนบ',
          },
        },
        INPUT: {
          AREA: {
            LABEL: 'พื้นที่',
            PLACEHOLDER: 'ระบุพื้นที่',
            VALIDATE: {
              REQUIRED: 'ต้องระบุข้อมูลนี้',
            },
          },
        },
        BUTTON: {
          SEARCH: 'ค้นหา',
          DOWNLOAD: 'ดาวน์โหลด',
        },
      },
    },
  },
};
